import type { RootState } from 'store/root/reducers';

const getCurrentState = (state: RootState) => state['customer'];

const customerSelectors = {
  state: (state: RootState) => getCurrentState(state),
  summary: (state: RootState) => getCurrentState(state).summary,
  customers: (state: RootState) => getCurrentState(state).customers,
  totalCustomers: (state: RootState) => getCurrentState(state).totalCustomers,
  params: (state: RootState) => getCurrentState(state).params,
  loadingTable: (state: RootState) => getCurrentState(state).loadingTable,
  customersByGroup: (state: RootState) => getCurrentState(state).customersByGroup,
  detail: (state: RootState) => getCurrentState(state).detail,
  customerDetailInfo: (state: RootState) => getCurrentState(state).detail.data,
  customerTransactions: (state: RootState) => getCurrentState(state).detail.transactions,
};

export default customerSelectors;
